import type {RouteMiddleware} from "#app/composables/router"
import {useNotification} from "@/composables/useNotification"

export default defineNuxtRouteMiddleware((to): RouteMiddleware => {
    const {$can} = useNuxtApp()
    if (to.meta?.mustPossessAbility) {
        if (!$can(to.meta.mustPossessAbility.action, to.meta.mustPossessAbility.subject)) {
            useNotification().warning(useNuxtApp().$i18n.t('canNotAccessRoute'))
            return navigateTo(useLocalePath()('/'))
        }
    }
})